import React from 'react'
import "./NoInternetModel.scss"
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';

const NoInternetModel = ({closeModel}) => {
    return <>
        <div className="location-guid-modal_">
            <div className="modal-close-button_">
                <CloseTwoToneIcon className='modal-close-icon_' onClick={closeModel} />
            </div>
            <div className="location-guid-modal-container_">
                <div className="location-guid-modal-header_">
                    <div className="location-guid-modal-heading_">No Internet Connection 🌐 </div>
                </div>
                <div className="location-guid-modal-body_">
                    <div className="no-internet-connecton-message_">Please turn on your WiFi or mobile data and Refresh Page to continue</div>
                </div>
            </div>
        </div>
    </>
}

export default NoInternetModel